import React, { ReactNode } from 'react';

interface HelpSectionProps {
  id: string;
  title: string;
  children: ReactNode;
}

const HelpSection: React.FC<HelpSectionProps> = ({ id, title, children }) => {
  return (
    <section id={id} className="mb-10">
      <h2 className="text-2xl md:text-3xl font-bold mb-4">{title}</h2>
      {children}
    </section>
  );
};

export default HelpSection;